import { Suspense, useEffect, useState } from "react";
import { useShop } from "@/lib/shop-store";
import { lazyWithRetry } from "@/lib/lazy-retry";

const CartDrawer = lazyWithRetry(() =>
  import("@/components/CartDrawer").then((m) => ({ default: m.CartDrawer })),
);

/**
 * Le panier n'est jamais visible au chargement initial : son JS n'est
 * téléchargé qu'à la première ouverture (ou pendant le temps mort après
 * l'hydratation), ce qui allège le bundle critique.
 */
export function LazyCartDrawer() {
  const { cartOpen } = useShop();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (cartOpen) {
      setMounted(true);
      return;
    }
    const win = window as Window & {
      requestIdleCallback?: (cb: () => void) => number;
      cancelIdleCallback?: (id: number) => void;
    };
    if (win.requestIdleCallback) {
      const id = win.requestIdleCallback(() => setMounted(true));
      return () => win.cancelIdleCallback?.(id);
    }
    const timer = window.setTimeout(() => setMounted(true), 2500);
    return () => window.clearTimeout(timer);
  }, [cartOpen]);

  if (!mounted) return null;

  return (
    <Suspense fallback={null}>
      <CartDrawer />
    </Suspense>
  );
}
